module.exports = __webpack_public_path__ + "img/image63.d8110e80.png";